{
  "version": 1,
  "asset_id": "26e16542-1857-43b8-a304-d2b3baf86bde",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/26e16542-1857-43b8-a304-d2b3baf86bde/stamped-concrete-patio-finished-2.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/26e16542-1857-43b8-a304-d2b3baf86bde/stamped-concrete-patio-finished-2.webp",
  "original_filename": "stamped-concrete-patio-finished-2.webp",
  "size": 252608,
  "content_type": "image/webp",
  "created_at": "2026-09-11T22:26:22Z"
}
